import axios from 'axios';

const listar = async (): Promise<any> => {
  const res = await axios.get<any>(`montadoras`);
  return res.data;
};

export default {
  listar,
};
